import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrl: './title.component.scss'
})
export class TitleComponent {

  @Input() title: string;
  @Input() type?: string;
  @Input() numeroOrdine?: string;
  @Input() uploadDisabled?: boolean;
  @Input() actionsDisabled?: boolean;
  @Input() icon?: string;
  @Input() buttonTemplate?: TemplateRef<any>;
}
